import React, { createContext, useState, useContext } from 'react';

export const AuthContext = createContext({
  user: null,
  login: (user) => {},
  logout: () => {}
});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem('user');
    if (!stored) return null;

    const userData = JSON.parse(stored);

    // Migration: Check if we have the new token format with backend-issued JWT
    // New format will have both idToken (backend JWT) and auth0IdToken (Auth0 JWT)
    // Old format only has idToken (Auth0 JWT)
    // If we don't have auth0IdToken, this is old format and needs re-login
    if (userData?.idToken && !userData?.auth0IdToken) {
      // Old format detected - clear and force re-login
      console.warn('[AuthContext] Old token format detected. Please log out and log in again to get the new backend JWT token.');
      // For now, keep the user logged in but the backend will reject the token
      // The 401 error handling will prompt them to log in again
    }

    return userData;
  });

  const login = (userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('user');
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
